module.exports = __webpack_public_path__ + "img/hiking.16e817c7.svg";